var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleDollarSign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5074_55)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 5.3335H6.66671C6.31309 5.3335 5.97395 5.47397 5.7239 5.72402C5.47385 5.97407 5.33337 6.31321 5.33337 6.66683C5.33337 7.02045 5.47385 7.35959 5.7239 7.60964C5.97395 7.85969 6.31309 8.00016 6.66671 8.00016H9.33337C9.687 8.00016 10.0261 8.14064 10.2762 8.39069C10.5262 8.64074 10.6667 8.97987 10.6667 9.3335C10.6667 9.68712 10.5262 10.0263 10.2762 10.2763C10.0261 10.5264 9.687 10.6668 9.33337 10.6668H5.33337M8.00004 12.0002V4.00016M14.6667 8.00016C14.6667 11.6821 11.6819 14.6668 8.00004 14.6668C4.31814 14.6668 1.33337 11.6821 1.33337 8.00016C1.33337 4.31826 4.31814 1.3335 8.00004 1.3335C11.6819 1.3335 14.6667 4.31826 14.6667 8.00016Z",
    strokeWidth: 1.33,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5074_55"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleDollarSign);
export default __webpack_public_path__ + "static/media/circle-dollar-sign.b896f5dc6e615c211555557b48ee5196.svg";
export { ForwardRef as ReactComponent };